/**
 * Local guest row for Offline mode. Uses a client UUID so later seat/score
 * commands keep the same id when the guest is created on the server.
 */
export function buildLocalGuestPlayer(formData, { id } = {}) {
  const firstName = String(formData?.firstName || formData?.first_name || '').trim();
  const lastName = String(formData?.lastName || formData?.last_name || '').trim() || null;
  const mixedElo = Number(formData?.mixedElo ?? formData?.mixed_elo_rating);
  const levelsElo = Number(formData?.levelsElo ?? formData?.levels_elo_rating);
  return {
    id,
    first_name: firstName,
    last_name: lastName,
    name: [firstName, lastName].filter(Boolean).join(' '),
    gender: formData?.gender || null,
    is_guest: true,
    email: null,
    guest_invited_email: null,
    merged_at: null,
    is_active: true,
    avatar_url: null,
    mixed_elo_rating: Number.isFinite(mixedElo) ? mixedElo : 1200,
    levels_elo_rating: Number.isFinite(levelsElo) ? levelsElo : 1200,
    singles_elo_rating: null,
    club_games_played: 0,
    mixed_games_played: 0,
    levels_games_played: 0,
    gamesPlayedThisSession: 0,
    sessionMixedGames: 0,
    sessionLevelsGames: 0,
    gamesPlayedActual: 0,
    effectiveGamesPlayed: 0,
    gamesPlayedDisplay: '0',
  };
}

export function createOfflinePlayerId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return '00000000-0000-4000-8000-000000000000'.replace(/0/g, () =>
    Math.floor(Math.random() * 16).toString(16)
  );
}
